import React from 'react';
import MovingFooter from '../Partials/MovingFooter/MovingFooter';


const MovingFooterPage = (props) => {
    let text = 'OK'
    return (
        <MovingFooter
        />
    );
};
export default MovingFooterPage;
